import { Component, Input, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { CorporateService } from "../corporate.service";
import { SharedService } from "src/app/shared-modules/shared.service";

@Component({
  selector: "app-corporate-header",
  templateUrl: "./corporate-header.component.html",
  styleUrls: ["./corporate-header.component.css"],
})
export class CorporateHeaderComponent implements OnInit {
  token: any;
  userName: any;
  profilePic: any;
  @Input() profileDetails = "";

  constructor(
    private services: CorporateService,
    private router: Router,
    private snackBar: MatSnackBar,
    private shrdSrvce: SharedService
  ) {}

  ngOnInit(): void {
    this.GetProfileDetails();
    this.header();
  }

  public GetProfileDetails() {
    this.token = sessionStorage.getItem("corporate_token");
    this.userName = sessionStorage.getItem("corporateUserName");
    this.profilePic = sessionStorage.getItem("corporateProfilePic");
  }
  GoToProfile() {
    this.router.navigateByUrl("/corporate/profile");
  }
  GoToTrips() {
    this.router.navigateByUrl("/corporate/trips");
  }

  header() {
    let token = sessionStorage.getItem("corporate_token");

    this.services.GetProfile(token).subscribe((response: any) => {
      sessionStorage.removeItem("corporateUserName");
      this.userName = response.body.data.username;
      sessionStorage.setItem("corporateUserName", this.userName);
    });
  }
  corporateLogout() {
    // localStorage.clear();
    sessionStorage.removeItem("corporate_token");
    sessionStorage.removeItem("corporateProfilePic");
    sessionStorage.removeItem("corporateUserName");
    sessionStorage.removeItem("corporate_user_type");

    this.shrdSrvce.updateSearchDetails(null);
    
    this.services.corporateLogout(this.token).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.router.navigateByUrl("/");
          this.snackBar.open("Account logout successfully", "Success", {
            duration: 3000,
          });
        }
      },
      (error) => {
        {
          this.router.navigateByUrl("/");
          // localStorage.clear();
        }
      }
    );
  }
}
